module.exports = __webpack_public_path__ + "static/media/java-logo.5fee7724.png";


//////////////////
// WEBPACK FOOTER
// ./public/java-logo.png
// module id = 298
// module chunks = 0